import { request, queryString } from '../../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/settings/reason'

export default {
  addSet (values) {
    return request(`${url}/set`, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  getCode (code) {
    return request(`${url}/code/${code}`)
  },
  getAll () {
    return request(`${url}`)
  },
  removeSet (id) {
    return request(`${url}/set/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  saveSet (id, values) {
    return request(`${url}/set/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listItemsByPage (page, size, filter, sorting, text) {
    return request(`${url}/items/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  }
}
